import MarketsPageView from '@components/MarketsPageView';
import Seo from '@components/Seo';

function MarketsPage(): JSX.Element {
  return (
    <>
      <Seo
        title="Tectonic | Cross-chain Money Market | Lending & Borrowing"
        description="Generate passive yield on your assets earn attractive APYs based on a dynamic rate or Get an instant loan quickly and easily by using USDC, WBTC, WETH, CRO as collateral with more supported coins to come."
      />
      <MarketsPageView mode="MAIN" />
    </>
  );
}

export default MarketsPage;
